enum StocktakeImportErrorCode {
    ArgumentsInvalid = 'ArgumentsInvalid',
    NotFound = 'NotFound',
    StocktakeExcelError = 'StocktakeExcelError',
}
export default StocktakeImportErrorCode;
